import { render, staticRenderFns } from "./MsMessageBox.vue?vue&type=template&id=5ddff1bc&scoped=true"
import script from "./MsMessageBox.vue?vue&type=script&lang=js"
export * from "./MsMessageBox.vue?vue&type=script&lang=js"
import style0 from "./MsMessageBox.vue?vue&type=style&index=0&id=5ddff1bc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5ddff1bc",
  null
  
)

export default component.exports